module.exports = __webpack_public_path__ + "img/item15.d585d0da.png";